import { useCallback, useRef } from "react";
import type { ClassicEditor } from "ckeditor5";

export function useCKEditorInsertion() {
  const lastPositionRef = useRef<any>(null);

  // Save cursor position before rerender
  const saveSelection = useCallback((editor: ClassicEditor) => {
    const selection = editor.model.document.selection;
    lastPositionRef.current = selection.getFirstPosition();
  }, []);

  // Restore cursor position
  const restoreSelection = useCallback((editor: ClassicEditor) => {
    const lastPos = lastPositionRef.current;
    if (!lastPos) return;

    editor.model.change((writer) => {
      writer.setSelection(lastPos);
      editor.editing.view.focus();
    });
  }, []);

  // Replace selected text OR insert at cursor, then move cursor after
  const insertText = useCallback((editor: ClassicEditor, text: string) => {
    let updatedContent = "";

    editor.model.change((writer) => {
      const selection = editor.model.document.selection;
      const range = selection.getFirstRange();

      if (range == null) {
        return;
      }
      // 1️⃣ Remove selected text (supports replacing)
      writer.remove(range);

      // 2️⃣ Insert text at the EDITED range start
      const insertPos = range.start;
      writer.insertText(text, insertPos);

      // 3️⃣ Move cursor after inserted text
      const endPos = insertPos.getShiftedBy(text.length);
      writer.setSelection(endPos);

      // save for restoring on rerender
      lastPositionRef.current = endPos;

      // 4️⃣ Inform React Hook Form or parent
      updatedContent = editor.getData();
    });

    return updatedContent;
  }, []);

  return { saveSelection, restoreSelection, insertText };
}
